import { render, staticRenderFns } from "./jingfengLislist.vue?vue&type=template&id=2dcd4186&scoped=true"
import script from "./jingfengLislist.vue?vue&type=script&lang=js"
export * from "./jingfengLislist.vue?vue&type=script&lang=js"
import style0 from "./jingfengLislist.vue?vue&type=style&index=0&id=2dcd4186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd4186",
  null
  
)

export default component.exports